import { render, staticRenderFns } from "./SwiperWrapper.vue?vue&type=template&id=93490874&scoped=true"
import script from "./SwiperWrapper.vue?vue&type=script&lang=js"
export * from "./SwiperWrapper.vue?vue&type=script&lang=js"
import style0 from "./SwiperWrapper.vue?vue&type=style&index=0&id=93490874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93490874",
  null
  
)

export default component.exports